import { useMutation, useQueryClient } from "@tanstack/react-query";
import { driversService } from "../services";
import type { Driver, UpdateDriverPayload } from "../types";

export function useImportDrivers() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (file: File) => driversService.importDrivers(file),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["drivers"] });
		},
	});
}

export function useUpdateDriver() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({
			id,
			payload,
		}: {
			id: number;
			payload: UpdateDriverPayload;
		}) => driversService.updateDriver(id, payload),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["drivers"] });
		},
	});
}

export function useUpdateDriverStatus() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({
			driverId,
			isActive,
		}: {
			driverId: number;
			isActive: boolean;
		}) => driversService.updateDriverStatus(driverId, isActive),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["drivers"] });
		},
	});
}

export function useExportDrivers() {
	return useMutation<Driver[], void>({
		mutationFn: async () => {
			const response = await driversService.exportDrivers();
			return response;
		},
	});
}

export function usePresignedUrl() {
	return useMutation({
		mutationFn: ({
			driverId,
			fileName,
			contentType,
		}: {
			driverId: number;
			fileName: string;
			contentType: string;
		}) => driversService.getPresignedUrl({ driverId, fileName, contentType }),
	});
}
